// Maps an API mentor onto the shape the Mentorship components render.

const AVATAR_TONES = ["navy", "brand", "b700", "b300"];
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const initialsOf = (name) => {
  const parts = name.replace(/^@/, "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const toStringArray = (value) => (Array.isArray(value) ? value : []);

const mediaUrl = (path) =>
  path ? `${API_BASE}/${String(path).replace(/^\//, "")}` : "";

export const toMentorViewModel = (mentor) => ({
  id: mentor.id,
  name: mentor.name,
  initials: initialsOf(mentor.name),
  // avatar_class holds the public site's Tailwind classes, which don't apply
  // here, so pick a stable brand color per mentor instead.
  tone: AVATAR_TONES[mentor.id % AVATAR_TONES.length],
  cred: mentor.credentials || "",
  verified: Boolean(mentor.verified),
  founder: Boolean(mentor.founder),
  tag: mentor.bio || "",
  cats: toStringArray(mentor.categories),
  // Founders show "Verified paystub", everyone else "New mentor" (same
  // mapping the public site uses).
  badges: [
    mentor.founder
      ? ["success", "Verified paystub"]
      : ["neutral", "New mentor"],
  ],
  ig: mentor.instagram || "",
  cover: toStringArray(mentor.cover),
  video: mentor.video_caption || "",
  videoUrl: mediaUrl(mentor.intro_video_url),
  bookable: Boolean(mentor.bookable),
});
